import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initMetaPixel } from './utils/metaPixel';

import {Provider} from 'react-redux';
// import store from '../src/redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from '../src/redux/store';

try {
  localStorage.removeItem('persist:root');
} catch (error) {
  // Ignore storage access errors in restricted browser contexts.
}

initMetaPixel();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>
);